function crc16(str) {
  let crc = 0xFFFF;
  for (let i = 0; i < str.length; i++) {
    crc ^= str.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = (crc & 0x8000) ? ((crc << 1) ^ 0x1021) : (crc << 1);
      crc &= 0xFFFF;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}

function emv(id, val) {
  return `${id}${String(val.length).padStart(2, '0')}${val}`;
}

function normStr(s, max) {
  return s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9 @.\-_/+]/g, '')
    .substring(0, max)
    .trim();
}

export function gerarPayloadPix({ chave, nome, cidade, valor, txid }) {
  const chaveNorm   = chave.replace(/\D/g, '') || chave;
  const nomeLimpo   = normStr(nome, 25);
  const cidadeLimpa = normStr(cidade || 'Brasil', 15);
  const txidLimpo   = txid.replace(/[^a-zA-Z0-9]/g, '').substring(0, 25) || '***';

  const merchantInfo   = emv('26', emv('00', 'BR.GOV.BCB.PIX') + emv('01', chaveNorm));
  const additionalData = emv('62', emv('05', txidLimpo));

  let p = ''
    + emv('00', '01')
    + emv('01', '12')
    + merchantInfo
    + emv('52', '0000')
    + emv('53', '986')
    + (valor > 0 ? emv('54', valor.toFixed(2)) : '')
    + emv('58', 'BR')
    + emv('59', nomeLimpo)
    + emv('60', cidadeLimpa)
    + additionalData
    + '6304';

  return p + crc16(p);
}
